import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ConfirmationSuccess from 'fe-design-base/assets/illustrations/ConfirmationSuccess';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';

import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx, useTrackUxOnMount } from 'util/uxEvents';

import { resetCheckout } from '../slice';

const Success = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const trackUx = useTrackUx();

  useTrackUxOnMount(EVENT_ACTIONS.SIDE_DRAWER_VIEWED, TRACK_ACTION_TYPES.VIEW, {
    stage: 'checkout_completed',
  });

  const handleRedirect = useCallback(() => {
    trackUx(EVENT_ACTIONS.BUTTON_CLICKED, TRACK_ACTION_TYPES.CLICK, {
      button_text: toI18n('checkout_drawer.success.continue_posting'),
      element: 'primary_cta',
      stage: 'checkout_completed',
    });
    dispatch(resetCheckout());
    history.push('/hiring/v2/dashboard');
  }, [history, dispatch, trackUx]);

  return (
    <Box mt={12} ph={32} flex column gap={24} vcenter h="100%" w="400px">
      <ConfirmationSuccess w={173} />

      <Box>
        <Text variant="heading2">
          {toI18n('checkout_drawer.success.title')}
        </Text>
      </Box>

      <Button fullWidth variant="secondary" onClick={handleRedirect}>
        {toI18n('checkout_drawer.success.continue_posting')}
      </Button>
    </Box>
  );
};

export default Success;
